import styled from 'styled-components';

export const HomeWrapper = styled.div`
  max-width: 85%;
  margin: 0 auto;
  padding-top: 12%;
  background: #fff;
  @media (max-width: 720px) {
    padding-top: ${(props) => (props.noPadding ? '0' : '30px')};
    max-width: 100%;
  }
  .videoAd {
    display: ${(props) =>
      props.userType == 'B' ? 'none !important' : 'block'};
  }
`;

export const BannerContainer = styled.div`
  display: flex;
  align-items: center;
  justify-content: space-between;
  flex-wrap: wrap;
  background-image: linear-gradient(to bottom, #fef7d9, #fff);
  background: ${(props) => props.bannerbg};
  padding: 0 40px 0 74px;
  position: ${(props) => props.position};
  @media (max-width: 720px) {
    padding: 12px 12px 36px;
  }

  & .googlePlayBan {
    width: 100px;
    height: auto;
    margin-left: 16px;
    cursor: pointer;

    @media (max-width: 720px) {
      width: 80px;
    }
  }
`;

export const Welcomemylo = styled.h4`
  font-size: ${(props) => props.fontsize};
  font-weight: 500;
  color: #6e6e6e;
`;

export const BannerHome = styled.img`
  cursor: pointer;
  max-width: ${(props) => (props.twoPhone ? '548px' : '100%')};
  width: 100%;
  height: auto;
  aspect-ratio: ${(props) => props.ratio};
`;

export const Logo = styled.img`
  width: auto;
  height: 80px;
  margin-bottom: 2px;

  @media (max-width: 720px) {
    height: 40px;
  }
`;

export const MyloDesc = styled.p`
  width: 80%;
  color: rgb(0 0 0 / 54%);
  font-size: ${(props) => props.fontsize};
  padding: 6px 0 38px;

  @media (max-width: 720px) {
    padding: 6px 0 18px;
    width: 100%;
  }
`;

export const Columntwo = styled.div`
  flex-basis: 48%;

  @media (max-width: 720px) {
    flex-basis: 98%;
    order: ${(props) => (props.banner ? '-1' : '0')};
    text-align: center;
  }
`;

export const FooterBannerContainer = styled.div`
  overflow: hidden;
  position: relative;

  & div {
    position: absolute;
    left: 50%;
    bottom: 30px;
  }
`;

export const FooterBanner = styled.img`
  max-width: 100%;
  width: 100%;
  height: auto;

  @media (max-width: 720px) {
    transform: scale(1.66);
    padding: 30px 0;
  }
`;
